export const discountMsg: string[][] = [
  ['Sneaker App Download', 'the app to access everything sneaker'],
  ['Save Up', 'to 40% shop all our new markdowns'],
  ['Sneaker members', 'Get free shipping'],
  ['Free Delivery', 'to the store to your home'],
  ['Snow gear sale!', ' Save up to 30%'],
  ['Snow sale', 'up to 30% off snow gear'],
];
